module.exports = __webpack_public_path__ + "iconfont.svg?573255ced07e00d35d8d1eb071608132";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/iconfont.svg
// module id = 30
// module chunks = 0